// @ts-check

import React, { Component, Fragment } from "react"
import { Dropdown } from "ui"
import DefineAction from "../../actions/DefineAction"
import { text, keyvaluelist } from "../../attributes/items/primitives"
import DefineProperty from "../../properties/DefineProperty"
import { evaluateFormulas } from "../../formulas/evaluate"

/**
 * @augments {Component<BlockTypeProps, {value: string}>}
 */
export default class SelectBlocktype extends Component {
    state = {
        value: "",
    }
    clear = () => {
        return new Promise((resolve, reject) => this.setState({ value: "" }, resolve))
    }

    constructor(props) {
        super(props)
        const evaluate = evaluateFormulas(props.context)
        if (props.config.attributes.defaultValue) {
            this.state.value = evaluate(props.config.attributes.defaultValue)
        }
    }

    componentWillReceiveProps(newProps) {
        const evaluate = evaluateFormulas(newProps.context)
        const evaluateOld = evaluateFormulas(this.props.context)
        const newVal = evaluate(newProps.config.attributes.defaultValue)
        const oldVal = evaluateOld(this.props.config.attributes.defaultValue)
        if (oldVal !== newVal) {
            this.setState({ value: newVal })
        }
    }

    render() {
        const Wrapper = this.props.Wrapper
        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle }) => (
                    <Fragment>
                        <DefineProperty
                            name={attrs.name || this.props.id}
                            description="input value"
                            type="string"
                            value={this.state.value}
                            onPersistedValue={value => this.setState({ value })}
                            tags={["form"]}
                        />

                        <Dropdown
                            style={{ ...computedStyle, width: "100%" }}
                            value={this.state.value}
                            options={attrs.options}
                            onChange={value => {
                                this.setState({ value })
                            }}
                        />

                        <DefineAction name={this.props.id + ": Clear Select"} action={this.clear} />
                    </Fragment>
                )}
            </Wrapper>
        )
    }
}

SelectBlocktype.attributes = [
    text({ field: "name", label: "Field Name" }),
    keyvaluelist({
        field: "options",
        label: "Options (label, value)",
        keyName: "label",
        valueName: "value",
    }),
    text({ field: "defaultValue", label: "Starting value" }),
]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/form/SelectBlock.js